import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationSharedComponent } from './notification.component';

@NgModule({
    declarations: [
        NotificationSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        NotificationSharedComponent
    ]
})

export class NotificationSharedModule {}
